// IconPicker — 업무 인트라넷 프로그램·폴더 맥락에 맞춘 이모지 선택기.
// 음식·자연·운송·게임 등 업무와 무관한 아이콘은 제외하고, 프로그램 유형(카탈로그·앱·
// 예약·포트폴리오·게시판·폼·소개)과 업무 도메인(문서·데이터·소통·조직·금융·개발·디자인)
// 위주로 구성. 선택한 이모지는 프로그램/폴더/페이지 아이콘으로 저장된다.

export const ICON_CATEGORIES: { name: string; icons: string[] }[] = [
  { name: "문서·자료",   icons: ["📋","📁","📂","🗂️","📄","📑","🗒️","📝","📎","🏷️","🔖","📚","📖"] },
  { name: "데이터·일정", icons: ["📊","📈","📉","💹","🧮","📐","📅","📆","⏰","⌛","⏳"] },
  { name: "소통·알림",   icons: ["💬","💭","📨","📧","✉️","📢","📣","🔔","📞","📱"] },
  { name: "사람·조직",   icons: ["👤","👥","🧑‍💼","👨‍💻","👩‍💻","🤝","🏢","🏬","🏛️","👔","🎓"] },
  { name: "금융·결재",   icons: ["💰","💵","💳","🧾","💸","🏦","🪙","✅"] },
  { name: "개발·시스템", icons: ["💻","🖥️","⚙️","🛠️","🔧","🔌","🗄️","💾","⌨️","🤖","🌐","🔗"] },
  { name: "디자인·미디어", icons: ["🎨","🖼️","📷","🎬","🎥","🖌️","✏️","🎞️","🎭"] },
  { name: "앱·기능",     icons: ["🧩","📌","🎯","🔑","🔒","🛡️","🧭","🗺️","📍","💡","✨","⚡","🚩","🏆","📦"] },
];

export const DEFAULT_ICON = "🧩";

export function IconPicker({ value, onChange, height = 220 }: {
  value: string | null;
  onChange: (icon: string) => void;
  height?: number;
}) {
  return (
    <div style={{ border: "1px solid var(--border)", borderRadius: 8, padding: 8, maxHeight: height, overflowY: "auto", background: "var(--bg-0)" }}>
      {ICON_CATEGORIES.map((cat) => (
        <div key={cat.name} style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: "var(--text-3)", margin: "2px 2px 4px" }}>{cat.name}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(34px, 1fr))", gap: 4 }}>
            {cat.icons.map((ic) => (
              <button
                key={ic}
                type="button"
                onClick={() => onChange(ic)}
                title={ic}
                style={{
                  fontSize: 18, height: 34, lineHeight: "30px", borderRadius: 6, cursor: "pointer", padding: 0,
                  border: value === ic ? "2px solid var(--p-500,#6366f1)" : "1px solid var(--border)",
                  background: value === ic ? "rgba(99,102,241,0.12)" : "var(--bg-0)",
                }}
              >
                {ic}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
